// Components/HomePage/ScrollingTags.jsx

export default function ScrollingTags() {
  const tags = [
    "Strategic Construction Management",
    "High-Value Residential Projects",
    "Custom New Construction",
    "Full-Scale Home Remodels",
    "ADU Development",
    "HOA Reconstruction",
    "Building Envelope Rehabilitation",
    "Waterproofing & Structural Repair",
    "Construction Takeovers",
    "Restoration & Insurance Work",
    "Expert Witness Services",
    "Process-Driven Systems",
    "Third-Generation Craftsmanship",
    "Six-Figure Project Execution",
    "Complex Projects Done Right",
    "From Rough to Perfect",
  ];

  return (
    <>

      {/* Scrolling Tags */}
      <div className="overflow-hidden whitespace-nowrap bg-[#343a40] py-4 sm:py-6">
        <div className="inline-block animate-marquee">
          {tags.map((tag, idx) => (
            <span
              key={idx}
              className="mx-6 text-[#f8f9fa] font-semibold text-lg sm:text-xl md:text-2xl"
            >
              {tag}•
            </span>
          ))}
        </div>

        {/* Duplicate for seamless scrolling */}
        <div className="inline-block animate-marquee ml-12">
          {tags.map((tag, idx) => (
            <span
              key={idx}
              className="mx-6 text-[#e9ecef] font-semibold text-lg sm:text-xl md:text-2xl"
            >
              {tag}•
            </span>
          ))}
        </div>
      </div>
    </>
  );
}
